<template>
  <div class="edit-paiban-img">
    <breadcrumb
      :title="$route.query.line || $translateLang('排版图管理')"
      :childTitle="$translateLang('排版图模板编辑')"
      @goBackPage="goBackPage"
      class="breadcrumb-box"
    >
    </breadcrumb>
    <div class="content">
      <div class="left">
        <div class="paibanImg-base-info">
          <div class="base-info-item">
            <span class="title"
              ><span class="required">*</span
              >{{ $translateLang('模板名称') }}</span
            >
            <a-input
              style="width: 192px"
              id="editPaibanImg_templateName_input"
              v-model="templateName"
              @dragover="handleDragOver"
            ></a-input>
          </div>
          <div class="base-info-item">
            <span class="title ellipsis" :title="$translateLang('排版图名前缀')"
              ><span class="required">*</span
              >{{ $translateLang('排版图名前缀') }}</span
            >
            <a-input
              style="width: 192px"
              id="editPaibanImg_namePrefix_input"
              v-model="formData.imageNamePrefix"
              @dragover="handleDragOver"
            ></a-input>
          </div>
          <div class="base-info-item">
            <span class="title ellipsis" :title="$translateLang('排版图格式')"
              ><span class="required">*</span
              >{{ $translateLang('排版图格式') }}</span
            >
            <a-radio-group v-model="formData.imageFormat">
              <a-radio value="jpg" id="editPaibanImg_format_jpg_radio"
                >jpg</a-radio
              >
              <a-radio value="bmp" id="editPaibanImg_format_bmp_radio"
                >bmp</a-radio
              >
            </a-radio-group>
          </div>
          <div class="base-info-item">
            <span class="title ellipsis" :title="$translateLang('排版图尺寸')"
              ><span class="required">*</span
              >{{ $translateLang('排版图尺寸') }}</span
            >
            <div>
              <a-input
                style="width: 80px"
                id="editPaibanImg_size0_input"
                v-model="formData.width"
                @input="paibanImgLimit('width')"
                @blur="handleDraw('width')"
                @dragover="handleDragOver"
              ></a-input>
              <span class="operate">x</span>
              <a-input
                style="width: 80px"
                id="editPaibanImg_size1_input"
                v-model="formData.height"
                @input="paibanImgLimit('height')"
                @blur="handleDraw('height')"
                @dragover="handleDragOver"
              ></a-input>
            </div>
          </div>
        </div>
        <div
          class="detail-info"
          :class="{ 'detail-info-part': activeTab === 1 }"
        >
          <div class="tab">
            <span
              v-for="item in tabList"
              :key="`editPaibanImg_tab_${item.value}`"
              :class="{ 'active-tab': activeTab === item.value }"
              :title="$translateLang(item.label)"
              class="ellipsis"
              @click="handleChangeTab(item)"
              >{{ $translateLang(item.label) }}</span
            >
          </div>
          <div class="detail-info-item" v-show="activeTab === 0">
            <span class="title">{{ $translateLang('排版图旋转') }}</span>
            <a-select
              v-model="formData.bigPlank.rotate"
              style="width: 408px; margin-top: 8px"
              @change="handleChangeRotate"
            >
              <a-select-option
                v-for="item in rotateOptions"
                :key="`editPaibanImg_rotate_select_${item.value}`"
                :value="item.value"
                >{{ item.label }}</a-select-option
              >
            </a-select>
          </div>
          <div class="detail-info-item flex">
            <div class="margin-right">
              <span class="title">{{ $translateLang('字体类型') }}</span>
              <a-select
                style="width: 192px; margin-top: 8px"
                :value="
                  activeTab === 0
                    ? formData.bigPlank.fontFamily
                    : formData.part.fontFamily
                "
                @change="
                  handleChangeComSet(
                    $event,
                    activeTab === 0 ? 'bigPlank' : 'part',
                    'fontFamily'
                  )
                "
              >
                <a-select-option
                  v-for="item in fontFamilyOptions"
                  :key="`editPaibanImg_fontFamily_select_${item}`"
                  :value="item"
                >
                  {{ item }}
                </a-select-option>
              </a-select>
            </div>
            <div>
              <span class="title">{{ $translateLang('行间距') }}</span>
              <a-select
                style="width: 192px; margin-top: 8px"
                :value="
                  activeTab === 0
                    ? formData.bigPlank.lineSpace
                    : formData.part.lineSpace
                "
                @change="
                  handleChangeComSet(
                    $event,
                    activeTab === 0 ? 'bigPlank' : 'part',
                    'lineSpace'
                  )
                "
              >
                <a-select-option
                  v-for="item in lineSpaceOption"
                  :key="`editPaibanImg_lineSpace_select_${item}`"
                  :value="item"
                >
                  {{ item }}
                </a-select-option>
              </a-select>
            </div>
          </div>
          <div class="detail-info-item flex">
            <div class="margin-right flex flex-dir--top">
              <span class="title">{{ $translateLang('字体大小') }}</span>
              <a-select
                style="width: 192px"
                :value="
                  activeTab === 0
                    ? formData.bigPlank.fontSize
                    : formData.part.fontSize
                "
                @change="
                  handleChangeComSet(
                    $event,
                    activeTab === 0 ? 'bigPlank' : 'part',
                    'fontSize'
                  )
                "
              >
                <a-select-option
                  v-for="item in fontSizeOption"
                  :key="`editPaibanImg_fontSize_select_${item}`"
                  :value="item"
                  >{{ item }}</a-select-option
                >
              </a-select>
            </div>
            <a-checkbox
              :checked="activeTab === 0 ? bigPlankFontWeight : partFontWeight"
              style="margin-top: 34px"
              @change="
                handleChangeComSet(
                  $event,
                  activeTab === 0 ? 'bigPlank' : 'part',
                  'fontWeight'
                )
              "
              v-show="
                activeTab === 0
                  ? formData.bigPlank.fontFamily !== '黑体'
                  : formData.part.fontFamily !== '黑体'
              "
              >{{ $translateLang('字体加粗') }}</a-checkbox
            >
          </div>
          <a-checkbox
            v-show="activeTab === 1"
            v-model="formData.part.showOverflow"
            class="show-overflow-checkbox"
            >{{ $translateLang('文字溢出板件时标识线展示小板数据')
            }}<img
              src="@/assets/labelColor/error-circle.png"
              alt=""
              id="editPaibanImg-circle-tip"
              class="circle-tip"
              title="该功能只支持一张纸展示一个排版图"
          /></a-checkbox>
          <a-checkbox
            class="detail-info-item"
            v-show="activeTab === 1"
            v-model="formData.part.showHoleSlot"
            @change="changeShowHoleSlot"
            >{{ $translateLang('展示孔槽信息') }}</a-checkbox
          >
          <a-textarea
            style="width: 408px; margin-bottom: 16px"
            :style="{ height: activeTab === 0 ? '100px' : '110px' }"
            :value="
              activeTab === 0
                ? formData.bigPlank.code.template_string
                : formData.part.code.template_string
            "
            @focus="
              focusTextarea($event, activeTab === 0 ? 'bigPlank' : 'part')
            "
            @drop="dropDown($event)"
            @blur="
              blurSelect(
                $event,
                activeTab === 0 ? formData.bigPlank.code : formData.part.code,
                activeTab === 0 ? bigPlankCodeList : partCodeList
              )
            "
          ></a-textarea>
          <DataTagPool
            :tagList="activeTab === 0 ? bigPlankCodeList : partCodeList"
            :dropData.sync="dropData"
            type="labelNameShow"
            @selectChange="selectChange"
          ></DataTagPool>
          <div class="detail-info-item" v-show="activeTab === 0">
            <a-checkbox v-model="formData.bigPlank.isCustomName">{{
              $translateLang('自定义排版图名')
            }}</a-checkbox>
            <div v-show="formData.bigPlank.isCustomName" class="mt5">
              <a-input
                v-model="formData.bigPlank.customName.template_string"
                :title="formData.bigPlank.customName.template_string"
                @focus="focusTextarea($event, 'bigPlankCustomName')"
                @drop="dropDown($event)"
                @blur="
                  blurSelect(
                    $event,
                    formData.bigPlank.customName,
                    bigPlankCodeList
                  )
                "
              ></a-input>
            </div>
          </div>
        </div>
      </div>
      <div class="right">
        <div class="head-btn">
          <a-button class="save-btn" @click="handleSave">{{
            $translateLang('保存')
          }}</a-button>
        </div>
        <div class="svg-wrap">
          <div id="edit_paiban_img_canvas" v-html="svg"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { fetchModelData, saveModel } from '@/apis/paibanImg/index'
import { getElectronicSawLabel } from '@/apis/tag'
import DataTagPool from '@/components/dataTagPool'
import breadcrumb from '@/components/topBreadCrumb.vue'
import { buryPointApi } from '@/util/commonFuncs'
import { defaultPaibanData } from '@/util/defaultTagData'

import { createPaibanImg } from './util/createPaibanImg'

export default {
  components: {
    breadcrumb,
    DataTagPool,
  },
  data() {
    return {
      templateId: null,
      templateName: '',
      tabList: [
        {
          label: '大板排版图样式调整',
          value: 0,
        },
        {
          label: '小板排版图样式调整',
          value: 1,
        },
      ],
      activeTab: 0,
      rotateOptions: [
        { label: '0°', value: 0 },
        { label: '90°', value: 90 },
        { label: '180°', value: 180 },
        { label: '270°', value: 270 },
      ],
      fontFamilyOptions: ['微软雅黑', '黑体', '宋体'],
      lineSpaceOption: [1, 2, 3, 4],
      fontSizeOption: [4, 6, 8, 10, 12, 14, 16, 20, 26, 32],
      formData: {
        width: 793,
        height: 1122,
        imageNamePrefix: 'M',
        imageFormat: 'jpg',
        // 大板数据
        bigPlank: {
          rotate: 0,
          fontFamily: '微软雅黑',
          lineSpace: 1,
          fontSize: 8,
          fontWeight: 'normal',
          code: {
            label_keys: {
              '{大板序号}': 'canvasIndex',
              '{大板利用率}': 'usedRate',
              '{板件材质}': 'matCode',
              '{板件颜色}': 'texture',
              '{大板规格}': 'size',
            },
            template_string:
              '第{大板序号}张大板  利用率：{大板利用率}\n材质：{板件材质}  颜色：{板件颜色}  规格：{大板规格}',
          },
          isCustomName: false,
          customName: {
            template_string: '',
            label_keys: {},
          },
        },
        // 小板数据
        part: {
          fontFamily: '微软雅黑',
          lineSpace: 1,
          fontSize: 8,
          fontWeight: 'normal',
          showOverflow: false,
          showHoleSlot: true,
          code: {
            label_keys: {
              '{板件名称}': 'partName',
              '{切割尺寸}': 'realRect',
            },
            template_string: '{板件名称}\n{切割尺寸}',
          },
        },
      },
      // 大板标签数据列表
      bigPlankCodeList: [],
      // 小板数据列表
      partCodeList: [],
      // 选中DOM
      recodeSelect: null,
      dropData: {},
      // 复制的后台拖拽逻辑
      // 记录选择的文本域dom
      selectedDom: null,
      // 记录选择的文本域dom 类型 大板还是小板
      selectedDomType: '',
      equationPosition: 0,
      canvasId: null,
      svg: '',
      bigPlankFontWeight: false,
      partFontWeight: false,
    }
  },
  methods: {
    goBackPage() {
      let from = this.$route.query.from ? 'temp' : undefined
      this.$router.push({
        path: '/paibanImg',
        query: {
          from,
        },
      })
    },

    handleChangeTab(item) {
      this.activeTab = item.value
    },

    // 排版图尺寸输入限制
    paibanImgLimit(type) {
      this.formData[type] = Number(
        this.formData[type].toString().replace(/^(0+)|[^\d]+/g, '')
      )
    },

    // 排版图尺寸输入限制后重新绘制
    handleDraw(type) {
      const MIN_SIZE = 100
      if (this.formData[type] < MIN_SIZE) {
        this.formData[type] = MIN_SIZE
      }
      this.draw()
    },

    // 排版图旋转
    handleChangeRotate() {
      this.draw()
    },

    // 修改大板及小板的 公用设置
    handleChangeComSet(e, obj, key) {
      this.formData[obj][key] = e.target ? e.target?.checked : e
      if (key === 'fontWeight') {
        this[`${obj}FontWeight`] = e.target?.checked
      }
      this.formData[obj].fontWeight =
        this[`${obj}FontWeight`] && this.formData[obj].fontFamily !== '黑体'
          ? 'bold'
          : 'normal'
      this.draw()
    },

    // 展示孔槽勾选变化
    changeShowHoleSlot() {
      this.draw()
    },

    // 拖动放入时, 阻止事件冒泡
    handleDragOver(event) {
      event.preventDefault()
    },

    // 文本域选中时, 记录dom元素
    focusTextarea(e, type) {
      this.clearSelectedDom()
      this.selectedDom = e.target
      this.selectedDomType = type
    },

    // 清除记录的dom
    clearSelectedDom() {
      this.selectedDom = null
      this.selectedDomType = ''
    },

    dropDown(event) {
      // 需要定时器, 异步处理一下, 才能获取到值
      setTimeout(() => {
        // 将光标的结束位置赋值给起始位置, 取消拖动之后的选中问题, 如果看不懂, 可以自己注释了试一下
        this.equationPosition = event.target.selectionStart
        event.target.selectionStart = event.target.selectionEnd
      })
    },

    // 选中代码块里面的代码, 点击标签切换
    selectChange(tag) {
      if (!this.selectedDom) return
      const codeInfo = this.getSelectedCodeInfo()
      if (!codeInfo) return

      const { codeConfig, codeList } = codeInfo
      const startIndex = this.selectedDom.selectionStart
      const endIndex = this.selectedDom.selectionEnd
      const str = codeConfig.template_string || ''
      const newStr = [...str]
      newStr.splice(startIndex, endIndex - startIndex, tag)
      codeConfig.template_string = newStr.join('')
      codeConfig.label_keys = this.tempStringToObj(newStr.join(''), codeList)
      this.draw()
      this.clearSelectedDom()
    },

    getSelectedCodeInfo() {
      if (this.selectedDomType === 'bigPlankCustomName') {
        return {
          codeConfig: this.formData.bigPlank.customName,
          codeList: this.bigPlankCodeList[0]?.arr ?? [],
        }
      }
      if (this.selectedDomType === 'bigPlank') {
        return {
          codeConfig: this.formData.bigPlank.code,
          codeList: this.bigPlankCodeList[0]?.arr ?? [],
        }
      }
      if (this.selectedDomType === 'part') {
        return {
          codeConfig: this.formData.part.code,
          codeList: this.partCodeList[0]?.arr ?? [],
        }
      }
      return null
    },

    // 编辑框失焦保存选中文本
    blurSelect(e, code, list) {
      code.template_string = e.target.value
      code.label_keys = this.tempStringToObj(code.template_string, list[0].arr)
      this.draw()
    },

    // 根据字符串和list返回新的label_keys
    tempStringToObj(str, list) {
      if (!str) return {}
      const strReg = str.match(/(?<={).*?(?=})/g) ?? []
      const obj = {}
      strReg.forEach((item) => {
        if (!obj.hasOwnProperty(item)) {
          const find = list.find((d) => d.label_name_show == item)
          if (find) {
            obj[`{${item}}`] = find.label_name
          }
        }
      })
      return obj
    },

    // 保存
    handleSave() {
      if (
        !(
          this.templateName &&
          this.formData.imageNamePrefix &&
          this.formData.imageFormat &&
          this.formData.width &&
          this.formData.height
        )
      ) {
        this.$message({
          message: '请确认必填项都填写后，再保存！',
          type: 'warning',
          duration: 2000,
        })
        return
      }
      if (this.formData.bigPlank.isCustomName) {
        if (!this.formData.bigPlank.customName.template_string) {
          this.$message({
            message: '请输入自定义排版图名',
            type: 'warning',
            duration: 2000,
          })
          return
        }
      }
      const keys = ['bigPlank', 'part']
      // 大板及小板 字体加粗字段处理
      keys.forEach((key) => {
        this.formData[key].fontWeight =
          this[`${key}FontWeight`] && this.formData[key].fontFamily !== '黑体'
            ? 'bold'
            : 'normal'
      })
      let params = {
        data: this.formData,
        name: this.templateName,
      }
      // 有id 编辑模板
      if (this.$route.query.id) {
        params.id = this.$route.query.id
      }
      saveModel(params).then((res) => {
        if (res.status === 1) {
          this.$message({
            message: this.$translateLang('保存成功'),
            type: 'success',
          })
          this.goBackPage()
          buryPointApi(
            'paibanImgManage',
            params.hasOwnProperty('id') ? 'edit_tem' : 'add_tem'
          )
        } else {
          this.$message({
            message: res.data.err_msg,
            type: 'error',
          })
        }
      })
    },

    async draw() {
      // 编辑页 这种绘制方法就不支持 元素的移动。后续如果需要移位置可能要重新写
      let svgRes = await createPaibanImg(this.formData, defaultPaibanData, {
        total: 1,
      })
      this.svg = svgRes.svg
    },
  },
  async mounted() {
    this.templateId = this.$route.query.id
    if (this.templateId) {
      const modelDataRes = await fetchModelData(this.templateId)
      if (modelDataRes.status === 1) {
        this.templateName = modelDataRes.data.name
        this.formData = modelDataRes.data.data
        const keys = ['bigPlank', 'part']
        keys.forEach((key) => {
          this[`${key}FontWeight`] =
            modelDataRes.data.data[key].fontWeight === 'bold' ? true : false
        })
      }
    } else {
      this.templateName = `自定义排版图${this.$route.query.temLength}`
    }
    // 获取标签数据源信息
    getElectronicSawLabel('layout_model').then((res) => {
      if (res.status === 1) {
        this.bigPlankCodeList = [{ title: '', arr: res.data.plank }]
        this.partCodeList = [{ title: '', arr: res.data.small_plank }]
        this.draw()
      }
    })
  },
}
</script>

<style lang="less" scoped>
.edit-paiban-img {
  min-height: calc(100vh - 60px);
  /deep/.breadcrumb-box {
    position: relative;
    z-index: 1;
    height: 46px;
    padding: 0 !important;
    .bread-crumb-box {
      display: flex;
      align-items: center;
      height: 46px !important;
      background-color: #eee !important;
      .ant-breadcrumb {
        margin-top: 2px !important;
        padding: 0 !important;
        padding-left: 16px !important;
      }
    }
    .bread-crumb-box .bread-crumb-box-content {
      display: none !important;
    }
    .select-tag {
      position: absolute;
      bottom: 10px;
      left: 320px;
      display: flex;
      align-items: center;

      .el-icon-loading {
        margin-left: 5px;
        color: #18a8c7;
        font-size: 16px;
      }

      .progress {
        display: block;
        width: 180px;
        margin-left: 5px;
      }
    }
  }
  .content {
    display: flex;
    height: calc(100vh - 106px);
    .left {
      width: 440px;
      .title {
        margin-bottom: 8px;
        color: rgba(0, 0, 0, 0.9);
        font-weight: 500;
      }
      .required {
        color: red;
      }
      .paibanImg-base-info {
        display: flex;
        flex-wrap: wrap;
        padding: 16px;
        .base-info-item {
          display: flex;
          flex-direction: column;
          width: 47%;
          &:nth-child(odd) {
            margin-right: 24px;
          }
          &:nth-child(1),
          &:nth-child(2) {
            margin-bottom: 20px;
          }
          .operate {
            margin: 0 8px;
            color: rgba(0, 0, 0, 0.6);
          }
        }
      }
      .detail-info {
        padding: 15px 16px 0 16px;
        border-top: 1px solid #e7e7e7;
        .tab {
          display: flex;
          align-items: center;
          & > span {
            width: 204px;
            height: 32px;
            padding: 0 10px;
            color: rgba(0, 0, 0, 0.6);
            font-weight: 500;
            line-height: 32px;
            text-align: center;
            border: 1px solid #dcdcdc;
            border-radius: 3px 0 0 3px;
          }
          & > span:last-child {
            border-left: none;
            border-radius: 0 3px 3px 0;
          }
          .active-tab {
            color: #18a8c7;
            background: #eefaff;
            border-color: #18a8c7;
          }
          & > span.active-tab:last-child {
            border-left: 1px solid #18a8c7;
          }
        }
        &-item {
          margin-top: 12px;
          margin-bottom: 16px;
          .margin-right {
            margin-right: 24px;
          }
        }
        .show-overflow-checkbox {
          display: block;
        }
        .circle-tip {
          width: 16px;
          height: 16px;
          margin-top: -2px;
          margin-left: 5px;
        }
        .ant-checkbox-wrapper {
          color: rgba(0, 0, 0, 0.7);
          font-weight: normal;
        }
        .ant-checkbox-wrapper + .ant-checkbox-wrapper {
          margin-left: 0;
        }
        .ant-select {
          color: rgba(0, 0, 0, 0.7);
        }
        /deep/.tag_warp {
          height: 150px;
          overflow-y: auto;
          .tag_box {
            .tags {
              width: 100%;
              span {
                margin: 5px;
              }
            }
          }
        }
        &.detail-info-part /deep/.tag_warp {
          height: 180px;
        }
      }
    }
    .right {
      flex: 1;
      overflow: hidden;
      background-color: #f5f5f5;
      .head-btn {
        padding: 20px;
        text-align: right;
        .save-btn {
          width: 92px;
          color: #fff;
          background-color: #18a8c7;
        }
      }
      .svg-wrap {
        height: calc(100vh - 178px);
        padding: 20px 20px 0 20px;
        overflow: auto;
        text-align: center;
      }
    }
  }
}
</style>
